import { isDev } from '@js'
// test为开发环境跨域前缀
const pre = isDev() ? '/test' : ''
export default `${pre}/candidate/ats`


// WEBPACK FOOTER //
// ./src/api/basePath.js